<template>
  <div>
    <h1>Direcciones</h1>
    <List :items="addresses" :columns="columns" />
  </div>
</template>

<script>
import List from "@/components/gotrading/common/List.vue";
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "AddressesPage",
  components: { List },
  data() {
    return {
      addresses: [],
      columns: [
        { key: "country", label: "País" },
        { key: "city", label: "Ciudad" },
        { key: "address", label: "Dirección" },
        { key: "postalCode", label: "Código Postal" },
      ],
    };
  },
  async mounted() {
    try {
      const response = await wencesApi.get("/api/gotrading/addresses");
      this.addresses = response.data;
    } catch (error) {
      console.error("Error al obtener direcciones:", error);
    }
  },
};
</script>
